export default function ArticleBody() {
  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-6 py-8">

        {/* 1. コインランドリー開業の流れ */}
        <section id="section1" className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            1. コインランドリー開業の流れ
          </h2>

          <div className="space-y-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業の第一歩：市場調査（商圏・競合・需要分析）</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業の最初のステップは市場調査です。出店予定地の人口構成（単身者・ファミリー）、世帯数、洗濯需要、競合店舗の数や規模、営業時間、料金設定などを細かく調査し、売上のポテンシャルを把握します。一般的に商圏は半径500〜1,000mが目安で、競合との距離や駐車場の有無がコインランドリー経営の売上に大きく影響します。正確な市場調査が、開業後の安定した収益につながります。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業の要：立地選定・物件条件の確認</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業において、立地選定は売上を左右する最重要ポイントです。ロードサイド、住宅街、団地の近隣など、利用者が見込めるエリアを中心に検討し、駐車場の有無、電気容量、ガス供給量、水道管径、排気ダクトの設置可否、24時間営業の可否など、コインランドリー経営に欠かせない設備条件を現地で確認します。そのうえで、ターゲットに合わせたコンセプト設計を行い、必要な機器台数や容量のバランス、休憩スペース、防犯対策などの店づくりの方針を固めます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業準備：機器メーカー・販売店との具体打ち合わせ</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業に向けて、機器メーカーや販売店との打ち合わせに入ります。必要な機器構成、容量バランス、ランニングコスト、レイアウト図面、収支シミュレーション、補助金情報などを相談し、最適な設備プランを決定します。初期費用を抑えながら売上を最大化するための設備選定が、コインランドリー経営成功の鍵となります。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業工事：建築工事・設備工事の計画と初期費用</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業に向けた工事計画では、給排水工事、電気工事、ガス配管、排気ダクト工事、重量機器の設置に耐えるための土間工事、内装・外装工事、看板設置など多岐にわたります。これらは物件条件によって初期費用が大きく変動するため、慎重な計画と見積もりの比較が重要です。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業直前：機器の搬入・設置・試運転と料金設定</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                工事完了後は、洗濯乾燥機・乾燥機・両替機・精算システムなどの搬入と設置を行い、正常に稼働するかをチェックします。料金設定では、競合店舗の料金を参考に、利用者にとって使いやすい価格設定を行います。また、清掃頻度や集金スケジュール、トラブル対応方法などを明確にし、無人でのコインランドリー経営を安定させることで、開業後の売上を着実に積み上げます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業前の集客準備（店内掲示・販促施策）</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業前のオープン準備では、POP掲示や料金表、近隣向けチラシ、Googleビジネスプロフィールの設定、オープンキャンペーン企画などを行い、集客の準備を整えます。開業直後の売上を早期に安定させるためにも、事前の集客施策は欠かせません。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業当日の対応と開業後の安定運営</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                オープン当日はスタッフが使い方を案内し、トラブル対応などを行い、来店者に「安心して使えるお店」という印象を与えることが重要です。コインランドリー開業後は、店内清掃・日常点検・集金・売上記録などを継続的に行い、店舗を安定運営していきます。さらに、POSデータや利用傾向を分析し、料金見直しやキャンペーン企画を行うことで、継続的な売上向上につなげます。
              </p>
            </div>
          </div>
        </section>

        {/* 2. コインランドリー開業に必要な初期費用 */}
        <section id="section2" className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            2. コインランドリー開業に必要な初期費用
          </h2>
          <div className="bg-gray-50 p-8 rounded-lg">
            <p className="text-gray-700 leading-relaxed mb-6 font-normal">
              コインランドリー開業にかかる初期費用は、建設費も含めると一般的に3,000万〜5,000万円程度が目安です。内訳としては、建物費用が500万円〜1,000万円ほどで、新築か既存物件の改装かによって大きく変わります。設備工事費は800万〜1,200万円が一般的で、店舗の使いやすさや安全性に直結します。機器購入費は、20坪ほどの標準的なコインランドリー経営の場合、機械総額は約1,800万〜2,500万円程度になります。これらを踏まえると、建築費・設備工事費・販促費等も含めたコインランドリー開業の初期費用として3,100万〜4,700万円の範囲で見込むのが現実的です。初期費用の計画を正確に立てることが、開業後の安定した売上と収益確保につながります。
            </p>
          </div>
        </section>

        {/* 3. コインランドリーのランニングコスト */}
        <section id="section3" className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            3. コインランドリーのランニングコスト
          </h2>
          <div className="bg-gray-50 p-8 rounded-lg">
            <p className="text-gray-700 leading-relaxed mb-6 font-normal">
              コインランドリー経営における開業後の主要なランニングコストは、初期費用の規模に大きく左右されます。開業費用が3,100万円〜4,700万円の場合、10年返済としたときのローン返済額が最も大きな固定費となり、月々30万円〜48万円ほどを見込む必要があります。変動費の中心となるのは水道光熱費で、特に乾燥機を多く稼働させるためガス代の割合が大きく、月額20万円〜25万円程度が必要です。人件費は抑えられますが、衛生維持のための清掃委託費として月々3万円ほどが発生します。
            </p>
            <p className="text-gray-700 leading-relaxed font-normal">
              集客のための広告宣伝費は、コインランドリー開業初期は25万円〜30万円が必要となりますが、安定稼働後は立地の優位性や口コミによる自然集客に頼ることで、継続的な宣伝広告費を抑えたコインランドリー経営も可能です。さらに、機器メンテナンス費は保証期間内であっても部品代以外の作業費が発生する可能性があるため、修繕費の積立も考慮すべき重要なコストです。ランニングコストを正確に把握することで、売上目標と収支計画をより精度高く立てられます。
            </p>
          </div>
        </section>

        {/* 4. コインランドリー開業のメリット・注意点 */}
        <section id="section4" className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            4. コインランドリー経営のメリット・注意点
          </h2>

          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー経営のメリット：人件費を抑えた無人運営と清掃・巡回の重要性</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー経営は人件費がほとんどかからず、常駐スタッフも不要で運営できるのが大きなメリットです。その分、売上に対する利益率が高くなりやすい点も魅力です。注意点としては、無人だからこそ清掃や巡回を怠ると店舗の印象が下がります。定期清掃をスケジュール化し、監視カメラや遠隔チェックを組み合わせれば、清潔・安心の店舗を維持できます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー経営の売上：季節変動への対応とリピーター獲得</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー経営は年間を通して売上が安定しやすい一方、季節により利用されるメニューが変わる場合があります。時期に合わせたキャンペーンを行うことで、繁忙期の売上を強化し、閑散期でもリピーターを増やすことができます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー経営の売上最大化：地域ニーズに合った設備選び</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                広い需要を取り込めるのがコインランドリー経営の魅力ですが、地域に合わない設備構成だと需要を逃す可能性があります。商圏に合わせた機器容量バランスを設計すれば、コインランドリー経営の売上効率を最大化できます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業の初期費用：資産として回収できる投資計画</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業にはまとまった初期費用が必要ですが、土地・建物・機器は資産として残ります。商圏分析、設備選定、運営シミュレーションを専門家と行い、「無理のない収支計画」を立てれば、長期安定した売上と収益を実現できるコインランドリー経営が可能です。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー経営の評価を左右する店舗清潔度と売上の関係</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー経営は売上予測が比較的しやすく、キャッシュレス導入で管理も簡単です。しかし、清潔感が欠けると利用者離れにつながり、売上低下を招きます。POP掲示・除菌清掃・明るい照明・香り対策を取り入れれば、清潔感は大幅に向上し、口コミ評価も改善します。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー経営の自動運営：トラブル対応の仕組みづくり</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                遠隔監視・電子マネー精算により、コインランドリー経営はほぼ自動運営が可能です。トラブル時の電話サポート体制、案内POP、監視カメラによる確認環境があれば、無人運営でも十分に対応でき、安定した売上を維持できます。
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">コインランドリー開業は初心者でも可能：専門家との連携が成功の鍵</h3>
              <p className="text-gray-700 leading-relaxed font-normal">
                コインランドリー開業は成功事例が多く、サポート体制も充実しているため初心者でも始めやすい事業ですが、機器選び・立地判断・工事内容・初期費用の見積もりなどは専門性が高いためリスクがあります。メーカーや販売店と相談しながら進めることで、最適な出店計画を立てられ、失敗リスクを大幅に減らせます。
              </p>
            </div>
          </div>
        </section>

        <div className="mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/7c0003a815126b2df0ccf371d891040f.jpg"
            alt="コインランドリー経営の売上・収益分析"
            className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg mb-8"
            width="800"
            height="400"
            loading="lazy"
            decoding="async"
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 800px"
          />
        </div>

        <div id="section5" className="bg-gray-50 p-8 rounded-lg mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            5. コインランドリーの防犯対策
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 font-normal">
            コインランドリー経営における防犯対策は、無人店舗の安全性を守り、利用者の信頼を高めるうえで欠かせません。まず重要なのは防犯カメラの設置です。店内・店外の死角をなくすよう複数台を配置することで、犯罪の抑止力となります。
          </p>
          <p className="text-gray-700 leading-relaxed mb-4 font-normal">
            次にキャッシュレス決済の導入です。現金を減らすことで盗難リスクを大幅に低減し、両替機破壊などの被害を最小限に抑えることができます。キャッシュレス化は売上管理の効率化にも貢献します。
          </p>
          <p className="text-gray-700 leading-relaxed font-normal">
            さらに、機械警備の導入により、無人店舗であっても24時間体制の監視が可能になり、緊急時の駆けつけ対応も迅速になります。コインランドリー開業時から防犯対策を万全に整えることで、利用者が安心して通える店舗づくりが実現し、長期的な売上の安定にもつながります。
          </p>
        </div>

        <div className="mb-16">
          <img
            src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/91d8da3bc94cf7f16721d1a39eb5212e.jpeg"
            alt="コインランドリー経営の防犯・安全対策"
            className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg mb-8"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div id="section6" className="mt-12 bg-gray-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            6. まとめ
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 font-normal">
            コインランドリー経営は無人運営でありながら、地域に求められる生活密着型ビジネスです。安定した売上が期待できる一方、成功のカギとなるのは以下の4点です。
          </p>
          <ul className="list-disc list-inside text-gray-700 leading-relaxed mb-4 space-y-1 pl-2 font-normal">
            <li>正確な立地調査と商圏分析</li>
            <li>無理のない初期費用・収支計画の策定</li>
            <li>最適な機器構成と設備選び</li>
            <li>利用者が安心できる防犯対策の整備</li>
          </ul>
          <p className="text-gray-700 leading-relaxed font-normal">
            コインランドリー開業は、しっかりと準備すれば初心者でも参入しやすく、長期的な売上と収益が見込める魅力的な事業です。初期費用の計画から運営ノウハウまで、専門家のサポートを活用しながら、理想のコインランドリー経営を実現してください。
          </p>
        </div>

        {/* 8. よくある質問 */}
        <section id="section8" className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-teal-600 mr-4"></div>
            7. コインランドリー経営に関するよくある質問
          </h2>

          <div className="space-y-4">
            {[
              {
                q: "コインランドリー開業に必要な資格や許可はありますか？",
                a: "コインランドリーの開業に特別な資格は不要ですが、建築確認申請や消防法に基づく届出が必要な場合があります。また、ガス機器を使用する場合はガス工事の届出が必要です。物件の用途地域によっては出店できないケースもあるため、事前に専門家への確認をおすすめします。"
              },
              {
                q: "コインランドリー経営は副業・サイドビジネスとして可能ですか？",
                a: "はい、可能です。コインランドリー経営は無人運営が基本のため、本業を持ちながら副業として経営するオーナーも多くいます。清掃や集金は委託できるため、週に数時間程度の管理で運営できるケースもあります。ただし、開業初期は機器トラブルへの対応や集客施策に時間が必要です。"
              },
              {
                q: "コインランドリー開業の初期費用を抑える方法はありますか？",
                a: "中古機器の活用、既存テナントへの出店（スケルトン物件より改装費が安い）、補助金・助成金の活用などが有効です。ただし、初期費用を過度に削減すると機器の故障リスクや集客力の低下につながる場合があります。コスト削減と品質のバランスを専門家と相談しながら決めることが重要です。"
              },
              {
                q: "コインランドリー経営で失敗するケースはどのような場合ですか？",
                a: "主な失敗原因は、①立地選定のミス（競合が多い・人通りが少ない）、②初期費用の過小見積もりによる資金不足、③清掃・メンテナンス不足による店舗の劣化、④機器構成が地域ニーズに合っていない、の4点です。事前の市場調査と専門家によるシミュレーションが失敗リスクを大幅に低減します。"
              },
              {
                q: "コインランドリー開業から黒字化までどのくらいかかりますか？",
                a: "立地条件や稼働率によって異なりますが、一般的に開業から6ヶ月〜1年程度で月次黒字化するケースが多いです。開業直後は認知度が低いため売上が安定しにくいですが、口コミやリピーターが増えることで徐々に売上が向上します。開業前の集客準備（チラシ・Googleビジネスプロフィール等）が早期黒字化の鍵です。"
              },
              {
                q: "コインランドリー経営に向いている土地・物件の条件は？",
                a: "理想的な条件は、①駐車場が確保できる（3〜5台以上）、②幹線道路沿いや住宅密集地に近い、③電気容量・ガス・水道が十分に確保できる、④視認性が高い（看板が目立つ）、⑤競合店から500m以上離れている、の5点です。これらの条件を満たす物件ほど、コインランドリー経営の売上が安定しやすくなります。"
              },
              {
                q: "コインランドリーの機器はどのメーカーが良いですか？",
                a: "国内主要メーカーとしては、三洋電機（アクア）、東芝、パナソニック、海外ではエレクトロラックスなどがあります。各メーカーによって機器の特徴・価格・アフターサービスが異なります。重要なのはメーカー選びよりも、地域の需要に合った容量バランスと機器構成です。専門販売店に相談することで、最適な機器選定が可能です。"
              },
              {
                q: "コインランドリー経営の将来性はありますか？",
                a: "コインランドリー市場は2022年時点で約1,000億円規模に達しており、共働き世帯の増加・大型洗濯需要の高まり・悪天候の増加などを背景に、今後も安定した需要が見込まれます。市場は成熟期に入りつつありますが、サービス品質・清潔感・利便性で差別化できる店舗は引き続き高い売上を維持できます。"
              }
            ].map((item, index) => (
              <details key={index} className="bg-gray-50 rounded-lg overflow-hidden group">
                <summary className="flex items-start gap-3 p-5 cursor-pointer list-none">
                  <span className="flex-shrink-0 w-7 h-7 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">Q</span>
                  <span className="font-semibold text-gray-900 text-base leading-relaxed">{item.q}</span>
                  <i className="ri-arrow-down-s-line ml-auto flex-shrink-0 text-teal-600 text-xl transition-transform group-open:rotate-180"></i>
                </summary>
                <div className="px-5 pb-5 pl-15">
                  <div className="flex items-start gap-3 pt-2 border-t border-gray-200">
                    <span className="flex-shrink-0 w-7 h-7 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center text-sm font-bold mt-0.5">A</span>
                    <p className="text-gray-700 leading-relaxed font-normal text-sm">{item.a}</p>
                  </div>
                </div>
              </details>
            ))}
          </div>
        </section>

        {/* 専門家・運営会社情報 */}
        <section className="mb-12 bg-gradient-to-r from-teal-50 to-emerald-50 p-8 rounded-lg border border-teal-100">
          <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <i className="ri-building-2-line text-teal-600 text-2xl"></i>
            このサイトについて
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold text-gray-900 mb-2 text-base">運営会社</h3>
              <p className="text-gray-700 text-sm leading-relaxed font-normal mb-3">
                <strong>Next Stage（ネクストステージ）</strong>は、大阪を拠点にコインランドリー開業・経営支援を専門とするコンサルティング会社です。立地調査から機器選定、工事手配、開業後の運営サポートまで、コインランドリー経営に関するすべてのプロセスをワンストップで支援しています。
              </p>
              <p className="text-gray-700 text-sm leading-relaxed font-normal">
                これまでに多数のコインランドリー開業をサポートしてきた実績を持ち、初期費用の最適化から売上向上施策まで、オーナー様の立場に立ったアドバイスを提供しています。
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2 text-base">専門サービス内容</h3>
              <ul className="space-y-2 text-sm text-gray-700 font-normal">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>無料の立地調査・商圏分析</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>収支シミュレーション・初期費用の見積もり</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>機器選定・レイアウト設計のアドバイス</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>工事業者の手配・施工管理</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>開業後の運営サポート・売上改善提案</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>中古機器の売買・テナント情報の提供</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-teal-200">
            <p className="text-xs text-gray-500 leading-relaxed"><br /></p>
          </div>
        </section>

      </div>
    </div>
  );
}
